import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowFitTopLeft32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconArrowFitTopLeft32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9 5a4 4 0 0 0-4 4v11.5a1 1 0 1 0 2 0V9q.001-.27.068-.519L23.59 25.003h-7.244a1 1 0 1 0 0 2h10.657V16.347l-1-.001h1a1 1 0 1 0-2 0h1-1v7.242L8.483 7.068Q8.73 7 8.998 7H20.5a1 1 0 1 0 0-2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowFitTopLeft32);
